import { Component, OnInit, Input, EventEmitter, DoCheck, Output } from '@angular/core';
import { RanchFertilizerViewModel, NutrientTotalValidationErrors, OrganicFertilizer } from '../interfaces';
import { FormComponent } from '../../../../shared/form/form';
import { eFertilizerFormulationTypes } from '../../../../../interfaces/constants';
import { FormGroup } from '@angular/forms';
import { Fertilizer } from '../fertilizer.class';

@Component({
	moduleId: module.id,
	selector: 'fertilizer-edit',
	templateUrl: 'edit.html',
	styleUrls: ['edit.scss']
})

export class FertilizerEditComponent extends FormComponent implements OnInit, DoCheck {

	@Input()
	fertilizer: RanchFertilizerViewModel;

	/**
	 * Set by the hosting view. Ranch settings hides mineralization-only fields;
	 * the admin fertilizers page keeps them visible.
	 */
	@Input()
	showMineralizationFields = true;

	@Output()
	form: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public formulationTypes = eFertilizerFormulationTypes;

	public nutrientTotalPercentage: {
		total: number,
		validationError: NutrientTotalValidationErrors
	};

	public validationErrors = NutrientTotalValidationErrors;

	constructor() {
		super();

		this.nutrientTotalPercentage = {
			total: 0,
			validationError: null
		};
	}

	ngOnInit(): void {
		this.formErrors = {
			'Name': '',
			'PoundsPerGallon': '',
		}

		this.validationMessages = {
			'Name': {
				'required': 'field is required.',
			},
			'PoundsPerGallon': {
				'required': 'lbs/gallon is required.',
				'greaterThanNum': 'lbs/gallon must be greater than zero.'
			},
		}
	}

	onFertilizerTypeChange(isChemical: boolean): void {
		if (!isChemical && !this.fertilizer.OrganicFertilizer) {
			this.fertilizer.OrganicFertilizer = {
				Id: 0,
				NitrogenUnit: 1,
				TotalNitrogen: null,
				CNRatio: null,
				MineralNitrogen: 0,
				DryMatter: null,
				FOMFastFraction: 0,
				DecompositionRateFast: 0,
				DecompositionRateSlow: 0
			} as OrganicFertilizer;
		}
	}

	ngDoCheck(): void {
		if (!this.nutrientTotalPercentage) {
			return;
		}

		if (!this.f) {
			return;
		}

		if (this.fertilizer.IsChemical === false) {
			this.nutrientTotalPercentage.validationError = null;
			this.f.form.setErrors(null);
			this.form.emit(this.f.form);
			return;
		}

		this.nutrientTotalPercentage.total = Fertilizer.calculateTotalPercentage(this.fertilizer);

		this.nutrientTotalPercentage.validationError =
			Fertilizer.validateNutrientTotal(this.nutrientTotalPercentage.total);

		if (this.nutrientTotalPercentage.validationError) {
			this.f.form.setErrors({'total': false});
		}

		if (this.f && this.f.form) {
			this.form.emit(this.f.form);
		}
	}
}
